import Vue from 'vue'
import Chartist from '@/plugins/chartist'
import DashboardPlugin from '@/plugins/material-dashboard'
import Resource from 'vue-resource'
import vPhoneInput from '@/plugins/v-phone'

import '@/plugins/vee-validate'

import chartist from 'vue-chartist'

import jQuery from 'jquery'
global.$ = jQuery

// plugin setup
Vue.use(DashboardPlugin)
Vue.use(Resource)
Vue.use(chartist, {
  messageNoData: 'You have not enough data',
  classNoData: 'empty'
})
Vue.use(vPhoneInput)

// global library setup
Vue.prototype.$Chartist = Chartist
